/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Preview/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import FinalTag from './FinalTag/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import ViewAction from './ViewAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Preview({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Preview"
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let actionDocumentTreeNodeNameValueData = fromData.useDataValue({ viewPath,
context: 'action',
path: 'document_tree_node.name',
})
  return (<React.Fragment
>
<div
  data-testid="Preview.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Preview.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Letter"
/>
</div>
<div
  data-testid="Preview.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-1Af4GC': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="action.document_tree_node.name"
 text={actionDocumentTreeNodeNameValueData}
/>
<FinalTag
  viewPath={`${viewPath}/FinalTag`}
/>
</div>
<div
  data-testid="Preview.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<ViewAction
  viewPath={`${viewPath}/ViewAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}